import { THREE } from '@powerplay/common';
import { SettingsTypes } from '@powerplay/settings';
import { LightTypes } from './types';
export class ShadowsManager {
    settings;
    planes = [];
    scene;
    lightManager;
    map;
    planeAttachedToMesh = false;
    objectToFollowWithLight;
    CAMERA_OFFSET = 5;
    active = true;
    enabled = true;
    shadowPlaneResolution = new THREE.Vector2(6, 6);
    SHADOW_MATERIAL = new THREE.ShadowMaterial({
        opacity: 0.5,
        side: THREE.DoubleSide,
        depthWrite: false
    });
    enableCreatingShadowPlaneOnStart = true;
    maxTerrainShadowPlanes = 3;
    constructor(scene, lightManager, renderer, settings) {
        this.settings = settings;
        this.scene = scene;
        this.map = renderer.shadowMap;
        this.map.type = THREE.PCFShadowMap;
        this.lightManager = lightManager;
        const light = this.lightManager.getLight(LightTypes.directionalMain);
        if (light.shadow === undefined)
            return;
        light.shadow.camera = new THREE.OrthographicCamera(-this.CAMERA_OFFSET, this.CAMERA_OFFSET, this.CAMERA_OFFSET, -this.CAMERA_OFFSET, 0.1, 5000);
    }
    getPlane(index) {
        return this.planes[index];
    }
    setShadowCameraFrustumPlaneDimensions(top, right, bottom, left) {
        const light = this.lightManager.getLight(LightTypes.directionalMain);
        if (light.shadow === undefined || !(light.shadow.camera instanceof THREE.OrthographicCamera))
            return;
        light.shadow.camera.left = -left;
        light.shadow.camera.right = right;
        light.shadow.camera.top = top;
        light.shadow.camera.bottom = -bottom;
        light.shadow.camera.updateProjectionMatrix();
    }
    setShadowPlaneResolution(valueX, valueY) {
        this.shadowPlaneResolution.set(valueX, valueY);
    }
    isEnabled(settingsQualityValue = this.settings.getSetting(SettingsTypes.quality)) {
        return (settingsQualityValue > 3);
    }
    setTerrainShadowPlane(mesh) {
        let count = this.planes.length;
        if (count >= this.maxTerrainShadowPlanes) {
            for (let i = 0; i < count; i += 1) {
                if (i === 0)
                    this.planes[i].visible = false;
                this.planes[i] = this.planes[i + 1];
            }
            count = this.maxTerrainShadowPlanes - 1;
        }
        this.planes[count] = mesh;
        this.planes[count].receiveShadow = this.enabled;
        this.planes[count].material = this.SHADOW_MATERIAL;
    }
    setShadowMaterialToMesh(mesh) {
        mesh.material = this.SHADOW_MATERIAL;
        mesh.receiveShadow = true;
    }
    init() {
        this.createPlane();
        this.setEnabled(true);
        this.setTextureSize(8);
    }
    setTextureSize = (value) => {
        if (value <= 0)
            return;
        const light = this.lightManager.getLight(LightTypes.directionalMain);
        if (light.shadow === undefined)
            return;
        light.shadow.mapSize.set(value, value);
        if (light.shadow.map) {
            light.shadow.map.dispose();
            light.shadow.map = null;
        }
    };
    setActive = (active) => {
        this.active = active;
    };
    setEnabled = (enabled, force = false) => {
        if (!this.active && !force)
            return;
        this.enabled = enabled;
        const light = this.lightManager.getLight(LightTypes.directionalMain);
        light.castShadow = enabled;
        this.map.enabled = enabled;
        this.planes.forEach((plane) => {
            plane.receiveShadow = enabled;
        });
    };
    createPlane() {
        if (!this.enableCreatingShadowPlaneOnStart)
            return;
        const geometry = new THREE.PlaneGeometry(this.shadowPlaneResolution.x, this.shadowPlaneResolution.y);
        geometry.rotateX(Math.PI / 2);
        geometry.translate(0, 0.02, 0);
        this.planes[0] = new THREE.Mesh(geometry, this.SHADOW_MATERIAL);
        this.scene.add(this.planes[0]);
        this.planeAttachedToMesh = false;
    }
    attachPlaneToObject(object, index = 0) {
        if (this.planeAttachedToMesh)
            return;
        this.scene.remove(this.planes[index]);
        object.add(this.planes[index]);
        this.planes[index].position.set(0, 0, 0);
        this.planes[index].rotation.set(0, 0, 0);
        this.planes[index].updateMatrix();
        this.setObjectToFollowWithLight(object);
        this.planeAttachedToMesh = true;
    }
    detachPlaneToObject(object, objectToFollowWithLight, index = 0) {
        if (!this.planeAttachedToMesh)
            return;
        object.remove(this.planes[index]);
        this.scene.add(this.planes[index]);
        this.setObjectToFollowWithLight(objectToFollowWithLight);
        this.planeAttachedToMesh = false;
    }
    setObjectToFollowWithLight(object) {
        this.objectToFollowWithLight = object;
    }
    setVisibility(visibility, index = 0) {
        this.planes[index].visible = visibility;
        this.map.enabled = visibility;
    }
    followObjectWithLight() {
        if (this.objectToFollowWithLight)
            this.lightManager.followLightWithObject(this.objectToFollowWithLight);
    }
    adjustPositionY(y, index = 0) {
        this.planes[index].position.setY(y);
        this.planes[index].updateMatrix();
    }
}
//# sourceMappingURL=ShadowsManager.js.map